enum BannerCategory {
  AdHoc = "Ad hoc",
  Core = "Core"
}

export default BannerCategory;
